<div class="card">
    <h1>Raven Priorities</h1>
    <grid #grid [tableSettings]="tableSettings" [gridSettings]="gridSettings"></grid>
</div>
<div class="buttons-panel">
    <p-button type="button" label="Check" (onClick)="check()"></p-button>
</div>